import { render, staticRenderFns } from "./calendarEventBasic.vue?vue&type=template&id=2b8e578c&scoped=true&"
import script from "./calendarEventBasic.vue?vue&type=script&lang=js&"
export * from "./calendarEventBasic.vue?vue&type=script&lang=js&"
import style0 from "./calendarEventBasic.vue?vue&type=style&index=0&id=2b8e578c&prod&scoped=true&lang=css&"
import style1 from "./calendarEventBasic.vue?vue&type=style&index=1&id=2b8e578c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8e578c",
  null
  
)

export default component.exports